<div class="card tabulated-form-card">
  <div class="card-body tabulated-form-main">
    <ng-content select="[tabulatedFormMain]"></ng-content>
  </div>

  <div class="card-header tabulated-form-tabs" *ngIf="tabs.length">
    <ul class="nav nav-tabs card-header-tabs" role="tablist">
      <li class="nav-item" *ngFor="let tab of tabs">
        <button
          type="button"
          class="nav-link"
          role="tab"
          [class.active]="activeTab === tab.id"
          [class.disabled]="tab.disabled"
          [attr.aria-selected]="activeTab === tab.id"
          [attr.aria-disabled]="tab.disabled ? 'true' : null"
          (click)="selectTab(tab)"
        >
          {{ tab.label }}
        </button>
      </li>
    </ul>
  </div>

  <div class="card-body tabulated-form-body p-0">
    <div class="tab-content p-0">
      <ng-content></ng-content>
    </div>
  </div>
</div>
